import { graphql } from '../gql'

export const GET_ACTIVE_ORDER_ID_QUERY = graphql(`
  query GetActiveOrderId {
    activeOrder {
      id
      totalQuantity
    }
  }
`)

export const ADD_ITEMS_TO_ORDER_MUTATION = graphql(`
  mutation AddItemsToOrder($inputs: [AddItemInput!]!) {
    addItemsToOrder(inputs: $inputs) {
      order {
        id
        totalWithTax
        lines {
          id
          linePriceWithTax
          productVariant {
            id
          }
        }
      }
      errorResults {
        __typename
        ... on ErrorResult {
          errorCode
          message
        }
      }
    }
  }
`)

export const SET_ORDER_CUSTOM_FIELDS_MUTATION = graphql(`
  mutation SetOrderCustomFields($input: UpdateOrderInput!) {
    setOrderCustomFields(input: $input) {
      __typename
      ... on Order {
        id
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const ADD_ITEM_TO_ORDER_MUTATION = graphql(`
  mutation AddItemToOrder($productVariantId: ID!, $quantity: Int!) {
    addItemToOrder(productVariantId: $productVariantId, quantity: $quantity) {
      __typename
      ... on Order {
        id
        code
        state
        totalQuantity
        subTotalWithTax
        totalWithTax
        lines {
          id
          productVariant {
            id
          }
        }
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const ADD_PRODUCT_BUNDLE_TO_ORDER_MUTATION = graphql(`
  mutation AddProductBundleToOrder($productId: ID!, $orderId: ID!) {
    addProductBundleToOrder(productId: $productId, orderId: $orderId) {
      __typename
      ... on Order {
        id
        code
        state
        totalQuantity
        subTotalWithTax
        totalWithTax
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const ADD_KIT_TO_ORDER_MUTATION = graphql(`
  mutation AddKitToOrder($kitId: ID!, $orderId: ID!, $quantity: Int) {
    addKitToOrder(kitId: $kitId, orderId: $orderId, quantity: $quantity) {
      __typename
      ... on Order {
        id
        code
        state
        totalQuantity
        subTotalWithTax
        totalWithTax
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const ADJUST_KIT_QUANTITY_MUTATION = graphql(`
  mutation AdjustKitQuantityInOrder($orderId: ID!, $kitGroupId: String!, $quantity: Int!) {
    adjustKitQuantityInOrder(orderId: $orderId, kitGroupId: $kitGroupId, quantity: $quantity) {
      __typename
      ... on Order {
        id
        totalQuantity
        subTotalWithTax
        totalWithTax
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const REMOVE_KIT_FROM_ORDER_MUTATION = graphql(`
  mutation RemoveKitFromOrder($kitId: ID!, $orderId: ID!) {
    removeKitFromOrder(kitId: $kitId, orderId: $orderId) {
      __typename
      ... on Order {
        id
        totalQuantity
        subTotalWithTax
        totalWithTax
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const ADJUST_ORDER_LINE_MUTATION = graphql(`
  mutation AdjustOrderLine($orderLineId: ID!, $quantity: Int!) {
    adjustOrderLine(orderLineId: $orderLineId, quantity: $quantity) {
      __typename
      ... on Order {
        id
        totalQuantity
        subTotalWithTax
        totalWithTax
        lines {
          id
          quantity
          linePriceWithTax
        }
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const REMOVE_ORDER_LINE_MUTATION = graphql(`
  mutation RemoveOrderLine($orderLineId: ID!) {
    removeOrderLine(orderLineId: $orderLineId) {
      __typename
      ... on Order {
        id
        totalQuantity
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)

export const CLEAR_CART_MUTATION = graphql(`
  mutation ClearCart {
    removeAllOrderLines {
      __typename
      ... on Order {
        id
        totalQuantity
        lines {
          id
        }
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`)
